module.exports = __webpack_public_path__ + "static/img/icon-form-m_03.db491c64.svg";